/**
 * Build-time branding — env-driven with fallbacks so a **default** build stays
 * byte-identical (dev) while the **prod** build rebrands to "AI Maturity"
 * (AC-4.1 / AC-4.2). Values are read from `VITE_*` build vars, never constructed
 * (Env-vars-never-construct / Runtime-Resolved-Identifier-Mismatch — each name
 * grep-maps to a build-time declaration passed by the deploy workflow).
 *
 * The "Specs-Ray" wordmark is a fixed product name and is deliberately NOT
 * parameterized — only the subtitle after the colon and the admin group change.
 */

/** Subtitle shown after the "Specs-Ray" wordmark (browser tab + header). */
export const APP_TITLE: string = import.meta.env.VITE_APP_TITLE ?? 'SDD Maturity Dashboard';

/** Cognito/Entra group that grants access to admin-only surfaces (e.g. Calibration). */
export const ADMIN_GROUP: string = import.meta.env.VITE_ADMIN_GROUP ?? 'sdd-maturity-admin';
